import AttachmentsChunk from './AttachmentsChunk';

export default AttachmentsChunk;
